import React from "react";
import { Dropdown } from "antd";

import NotificationNavs from "./notificationnavs";

import images from "../../../../assets";

const items = [
  {
    label: <NotificationNavs />,
    key: "0",
  },
];

const NotificationDropdownContainer = () => {
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <img
        className="notification-bell"
        src={images.notificationBellIcon}
        alt="Notification"
      />
    </Dropdown>
  );
};

export default NotificationDropdownContainer;
